var _path, _path2, _path3, _circle, _circle2, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSedan = function SvgSedan(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 68 48"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D0BDF4",
    d: "M45.328 22.685H19.33c-.325-.833.254-4.724 1.722-5.18 2.222-.315 15.156-.315 17.378 0q.49.13.935.43c1.035.76 4.996 3.855 5.963 4.75"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#36354C",
    strokeWidth: 1.5,
    d: "M20.415 15.102c-1.325.442-6.245 3.328-9.78 5.506a6.63 6.63 0 0 1-3.474.994H4.708C2.542 21.602 2 23.407 2 24.31v3.25c0 5.633 3.972 7.402 5.958 7.583h52.287c.88 0 1.771-.156 2.484-.672 1.295-.94 2.858-2.686 3.183-5.286.542-4.333-1.559-5.575-2.708-5.958-1.422-.474-7.27-.533-11.37-.54a4.35 4.35 0 0 1-2.856-1.078c-4.834-4.238-5.946-5.146-10.978-6.16-.935-.189-1.472-.23-2.419-.347-5.878-.723-13.54-.541-15.166 0Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#36354C",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M40.999 22.685h4.108c.483 0 .71-.566.34-.876-1.683-1.404-4.886-3.566-8.781-3.998-2.154-.24-10.472-.542-13.541-.542-2.167 0-3.792 1.625-4.333 2.708-.434.867-.542 2.708 1.625 2.708h1.625m13.54 0H28M32.532 22.097l-.79-3.946"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 53.458,
    cy: 32.976,
    r: 5.208,
    fill: "#fff",
    stroke: "#36354C",
    strokeWidth: 1.5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 15.544,
    cy: 32.976,
    r: 5.208,
    fill: "#fff",
    stroke: "#36354C",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M55.622 32.976a2.167 2.167 0 1 1-4.333 0 2.167 2.167 0 0 1 4.333 0M17.708 32.976a2.166 2.166 0 1 1-4.333 0 2.166 2.166 0 0 1 4.333 0"
  })));
};
export default SvgSedan;